module.exports = __webpack_public_path__ + "static/rapid-development-12196210a15026f662a44d1259cee960.jpg";